import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type * as variableOverrides from '../../../variable-overrides'

import type { Feature } from '../feature'
import { getDraftVariableHolder } from './get-draft-variable-holder'

/**
 * Focuses scenario variables and seeds their current values for update drafts.
 */
export const focusVariablesOnEdit = store.effects.create(
  (
    feature: Feature,
    meFeature: me.Feature,
    variableOverridesFeature: variableOverrides.Feature,
  ) =>
    feature.actions.openEdit.observe().pipe(
      rxjs.withLatestFrom(meFeature.contexts.selectors.appContext.asObservable),
      rxjs.mergeMap(([action, appContext]) => {
        if (!appContext) {
          return rxjs.EMPTY
        }

        const { scenario } = action.data
        const holder = getDraftVariableHolder({
          appId: appContext.appId,
          scenarioId: scenario.id,
        })

        return rxjs.of(
          variableOverridesFeature.actions.setFocused
            .from(action)
            .create(holder),
          variableOverridesFeature.actions.putValues.from(action).create({
            holder,
            values:
              (scenario.variables as variableOverrides.models.Values) ?? {},
          }),
        )
      }),
    ),
)
